import {
  prefix
} from './src/utils/constant'
import {
  mapObject
} from './src/utils'
import './common'
import feedback from './src/components/business/feedback/feedback'

let components = {
  feedback
}

const install = Vue => {
  mapObject(components, component => {
    if (component.name) {
      Vue.component(prefix + component.name, component)
    } else {
      console.error('组件注册失败：缺少name')
    }
  })
}

export default {
  install
}
